import { render, staticRenderFns } from "./SearchProtein.vue?vue&type=template&id=7f1b86ee&"
import script from "./SearchProtein.vue?vue&type=script&lang=js&"
export * from "./SearchProtein.vue?vue&type=script&lang=js&"
import style0 from "./SearchProtein.vue?vue&type=style&index=0&id=7f1b86ee&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports